import styled from 'styled-components';

const Container = styled.div`
  padding: 20px;
`;

const PolicyText = styled.p`
  white-space: pre-wrap;
`;

export const TermsOfService = () => {
  return (
    <Container>
      <h1>이용약관</h1>

      <PolicyText>{termsPolicy}</PolicyText>
    </Container>
  );
};

const termsPolicy = `캡스 스마트냉난방 상품 할부판매 계약서 주요 약관 설명

1. 물품의 소유권

    ① 할부기간 중 소유권은 에스케이쉴더스(이하 “회사”라 함)에 있으며 고객은 할부금 완납 전에 회사의 사전 서면 승낙 없이 상품을 타인에게 양도하거나 질권을 설정하는 등의 임의 처분을 할 수 없습니다.
    ② 고객은 할부기간 중 계약에 따라 상품을 점유하여 이용할 권리만을 가질 뿐이고, 월 할부금 완납 등 고객이 본 계약상 모든 의무를 이행 완료한 경 우에 고객에게 소유권이 이전됩니다.

2. 할부금 변제방법

    ① 고객은 매월 고객이 지정한 납부일까지 월 할부금을 납입하여 변제합니다.
    ② 고객이 납입한 금액이 납입일 현재 고객의 채무 전액을 충당하기에 부족한 경우, 납입액은 납기일 기준으로 먼저 도래한 채무액부터 우선 충당합니다.

3. 이용조건

    고객이 설치를 요청한 장소(매장, 사무실 등) 내 이상상황(화재 및 도난 등)이 발생한 것으로 판단되면, 고객이 119/112에 직접 연락해야 하며, 이로 인하여 발생한 사고에 대해서는 회사는 책임을 지지 않습니다.

4. 상품의 설치 등

    ① 고객의 사정 또는 설치장소나 환경여건의 변화 등으로 기기의 추가, 위치 변경이 필요하거나 고객의 요청에 따라 통상적인 설치 비용이 아닌 추가 비용이 발생하는 경우 고객의 부담으로 합니다. 고객 요청에 의하여 상품이 이전 설치될 경우에도 같습니다.
    ② 상품이 인수 및 설치된 이후에는 고객의 단순 변심으로 인한 반품, 품목 교환은 불가합니다.

5. 상품의 유지보수

    ① 회사는 고객에게 계약일로부터 1년간 무상 유지보수 서비스를 제공하며, 무상유지보수 기간 이후에는 유상 유지보수로 비용은 고객의 부담으로 합니다.
    ② 다음 각 호의 경우에는 고객의 비용 및 책임으로 처리합니다.
        1. 고객이나 제3자의 책임 있는 사유로 인한 기기의 멸실, 훼손, 파손, 고장 등으로 교체나 보수가 필요한 경우
        2. 천재지변, 전쟁, 사변, 폭동, 화재 기타 회사의 책임 없는 사유로 인하여 교체나 보수가 필요한 경우
        3. 고객이 회사의 사전 동의 없이 제3자에게 임의로 기기의 보수나 수리를 의뢰함으로써 발생한 비용 및 그로 인한 기기의 멸실, 훼손, 파손, 고장 등으로 교체나 보수가 필요한 경우
        4. 본 계약의 종료 이후 발생하는 상품관리 및 유지보수에 드는 비용
    ③ 상품의 장애 또는 불량으로 인한 수리 기간 중에는 고객이 수동으로 조작해야 하며, 상품에 사용되는 베터리는 소모품으로 교체 주체는 고객입니다. 단, 고객의 요청 시 무상유지보수 기간 중 2회에 한하여 회사가 방문하여 무상교체 서비스를 제공합니다.

6. 청약의 철회

    ① 고객은 상품을 인도 받은 날로부터 7일 이내에 본 계약에 관한 청약을 철회할 수 있습니다. 다만, 고객의 요청에 의해 상품이 설치된 경우에는 철회할 수 없습니다.
    ② 청약의 철회는 위 기간 내에 고객이 철회의 의사표시를 유선으로 통보 또는 기재된 서면을 회사에게 발송한 날에 그 효력이 발생한 것으로 봅니다.

7. 계약의 해제

    고객 또는 회사는 다음 각 호의 경우에는 상대방에게 서면으로 상당한 기간을 정하여 그 이행을 최고하고 상대방이 그 기간 내에 이행하지 아니한 때에는 계약의 전부를 해제할 수 있습니다.
    1. 고객이 상품의 인수 및 설치를 특별한 사유 없이 지연함으로써 회사의 작업에 상당기간 지장을 초래하게 하는 경우
    2. 회사가 특별한 사유 없이 상품의 제공 및 설치를 거부하여 고객에게 불편을 끼치는 경우

8. 고객의 기한이익의 상실 및 잔여할부금의 일시 청구

    고객이 할부대금을 2회 이상 미납하거나 미지급 금액이 총 할부금의 1/10를 초과한 경우 또는 외국으로 이주하는 경우에는 할부금의 지급에 대한 기한의 이익을 상실하고 회사는 잔여 할부대금 전액에 대하여 고객에게 일시불 납입을 청구할 수 있습니다.

9. 고객의 기한 전 지급

    고객은 할부기간 중 언제라도 할부금 채무를 일시에 상환하고 상품의 소유권을 이전 받을 수 있으며, 이 경우 일시에 상환하는 금액은 나머지 할부기간 동안의 잔여 할부원금(및 연체이자)으로 합니다.

10. 고객의 의무

    ① 고객은 할부금을 완납하기 전에 주소, 자동이체계좌, 결제할 신용카드 등 지급 수단과 관련한 사항이 변경되는 경우 즉시 회사에 통보하여야 하며, 고객의 통지 불이행으로 인하여 발생하는 손실 또는 불이익에 대하여는 고객이 부담하여야 합니다.
    ② 고객의 할부금 변제의무는 상품의 도난, 화재, 재해, 기타의 사유로 인한 훼손, 멸실 시에도 계속됩니다.

11. 불가항력

    천재지변, 전쟁, 내란, 법령제도 개폐, 공권력에 의한 명령처분, 교통관계의 사고, 기타 회사의 귀책사유에 속하지 않는 사유로 인하여 회사의 본 계약 불이행 사태가 발생한 경우 회사는 이에 대한 책임을 지지 않습니다.

※ 자세한 사항은 캡스 스마트냉난방 상품 할부판매 계약서의 약관을 확인하시기 바랍니다.
`;
